import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: 'pythagorean_on_point',
    dependencies: [
        'levels_maths/xy_coords',
        'levels_maths/pythagorean_theorem'
    ]
})

let o = {
    name:  'O',
    color: '#226ea5'
}


function pointA () {
    return {
        x: random.fairChoiceInt(1, 5, {name: 'x'}),
        y: random.fairChoiceInt(1, 5, {name: 'y'}),
        name: 'A'
    }
}

function pointB (x) {
    return {x, y: 0, name: 'B', color: '#226ea5'}
}


function textAndAnswer (q, a) {
    q.addText(mathText.point(a))
    q.addText('carre(' + mathText.pointsDistance(o, a) + ') ?')
    q.answer = a.x * a.x + a.y * a.y
}


level.addQuestion({
    generator: function (q) {
        let a = pointA()

        let b = pointB(a.x)

        let geoScreen = q.addGeoScreen()

        geoScreen.addPolygon({
            points: [{x: 0, y: 0}, b, a]
        })

        q.addText(mathText.point(a))
        q.addText('carre(' + mathText.pointsDistance(o, b) + ') ?')

        q.answer = a.x * a.x
    }
})


level.addQuestion({
    generator: function (q) {
        let a = pointA()

        let b = pointB(a.x)

        let geoScreen = q.addGeoScreen()

        geoScreen.addPolygon({
            points: [{x: 0, y: 0}, b, a]
        })

        q.addText(mathText.point(a))
        q.addText('carre(' + mathText.pointsDistance(o, b) + ') + carre(' + mathText.pointsDistance(a, b) + ') ?')

        q.answer = a.x * a.x + a.y * a.y
    }
})


level.addQuestion({
    generator: function (q) {
        let a = pointA()

        let geoScreen = q.addGeoScreen()

        geoScreen.addPolygon({
            points: [{x: 0, y: 0}, pointB(a.x), a]
        })

        textAndAnswer(q, a)
    }
})


level.addQuestion({
    generator: function (q) {
        let a = pointA()

        let geoScreen = q.addGeoScreen()

        geoScreen.addPolygon({
            points: [{x: 0, y: 0}, a]
        })

        textAndAnswer(q, a)
    }
})


level.addQuestion({
    generator: function (q) {
        let a = pointA()

        textAndAnswer(q, a)
    }
})


export default level

